import React from 'react';
import { useFormikContext } from 'formik';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import CenteredContainer from 'components/CenteredContainer';
import ImageUpload, {
  UploadAspectRatios
} from 'legacy/common/components/wysiwyg-form/ImageUpload';
import { useImageUploadCommand } from 'legacy/common/hooks/useImageUploadCommand';

import { useOrganization } from '../../../../context/EditOrganizationProvider';
import { EditOrganizationFormValues } from '../../../../types/edit-organization';
import EditOrgMobileSkeleton from '../EditOrgMobileSkeleton';
import BadgeAndName from '../BadgeAndName';
import Location from '../Location';
import Description from '../Description';

import styles from './styles.module.scss';

const MobileForm = ({ uploadImage }) => {
  const { t } = useTranslation(['organizations']);
  const { values, touched, errors } =
    useFormikContext<EditOrganizationFormValues>();
  const uploadImageCommand = useImageUploadCommand();
  const { data } = useOrganization();

  if (data.isLoadingOrganization) {
    return <EditOrgMobileSkeleton />;
  }

  return (
    <div className="pb-24">
      <div
        className="bg-primary-200 relative bg-cover"
        style={{
          aspectRatio: '9 / 16',
          backgroundImage: `url(${values.coverImage})`
        }}
      >
        <ImageUpload
          photoUrl={values.coverImage}
          className="mx-auto"
          buttonStyle={{
            paddingBottom: '20px',
            paddingTop: '20px',
            background: 'transparent',
            boxShadow: 'none',
            borderRadius: 0
          }}
          editIconOnly
          defaultIconSize={120}
          isUploading={uploadImageCommand.isLoading}
          aspectRatio={UploadAspectRatios.NineToSixteen}
          label={t('form.coverImageLabel')}
          maxLabel={t('form.coverImageMax')}
          onUploadPhoto={uploadImage('coverImage')}
          error={(touched.coverImage && errors.coverImage) || ''}
          disabled={data.isSubmitting}
        />
        <div
          className={classNames(
            'z-0 absolute left-0 right-0 bottom-0 top-[35%] flex justify-end flex-col',
            styles.backgroundGradient
          )}
        >
          <BadgeAndName uploadImage={uploadImage} />
          <CenteredContainer>
            <Location />
          </CenteredContainer>
        </div>
      </div>
      <CenteredContainer>
        <Description />
      </CenteredContainer>
    </div>
  );
};

export default MobileForm;
